var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8399 3.0009L20.8327 8.04007L7.99283 21H3V15.9608L15.8399 3V3.0009ZM15.8399 5.54114L13.3648 8.04007L15.8399 10.539L18.3158 8.04007L15.8399 5.54114ZM14.5814 11.8091L12.1055 9.3102L4.77998 16.7055V19.2026H7.25592L14.5814 11.8082V11.8091ZM21 21H12.5068V19.2035H21V21Z",
    fill: "#002E68"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.da6a9f8eb2362c11ecc01db96c91d14c.svg";
export { ForwardRef as ReactComponent };